import { render } from "./PaginationArrows.vue?vue&type=template&id=6ea2bcbc&scoped=true"
import script from "./PaginationArrows.vue?vue&type=script&lang=js"
export * from "./PaginationArrows.vue?vue&type=script&lang=js"

import "./PaginationArrows.vue?vue&type=style&index=0&id=6ea2bcbc&scoped=true&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea2bcbc"]])

export default __exports__